import {Field} from 'redux-form'
import styles from './COGSField.css'
import settingField from 'components/Fields/ReduxForm/SettingField'

class ItemInventoryAlertField extends React.Component {
  render () {
    const {member, isSaved} = this.props
    return (<div className='mk-grouped-input'>
      <div className='form-group col-sm-8'>
        <Field
          component='input'
          disabled
          name={`${member}.name`}
          className={`form-control ${isSaved ? '' : styles['bg-white']}`}
        />
      </div>
      <div className='form-group col-sm-4'>
        <Field
          component={settingField}
          positiveNumberOnly
          dis={isSaved}
          name={`${member}.cogs`}
          inputClassName={`text-right ${styles['input-cogs']}`}
          prefixText='Rp'
          prefixTextClassName={styles['rp-cogs']}
          prefixTextClassNameError={styles['rp-cogs-error']}
        />
      </div>
    </div>)
  }
}

ItemInventoryAlertField.propTypes = {
  member: React.PropTypes.object
}

export default ItemInventoryAlertField



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/COGS/COGSFieldArray/COGSField/COGSField.js